import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY, from } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly _authService: AuthService, private readonly _router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (this.shouldProcessAsIs(req)) {
      return next.handle(this.addAuthHeaderIfExist(req));
    }

    if (!this._authService.isAuthorized()) {
      this._router.navigate(["/auth"]);
      return next.handle(req);
    }

    // ? Works only through promise for some reason, otherwise next.handle never invokes
    return from(
      this.refreshAuthTokensIfAccessExpired()
        .toPromise()
        .catch(() => this._authService.signOut().finally(() => this._router.navigate(["/auth"])))
    ).pipe(mergeMap(() => next.handle(this.addAuthHeaderIfExist(req))));
  }

  private shouldProcessAsIs(req: HttpRequest<any>) {
    return (
      req.url.endsWith("/refresh") ||
      req.url.endsWith("/logout") ||
      req.url.endsWith("/email-confirm") ||
      req.url.endsWith("/password-reset") ||
      this._router.url.startsWith("/auth") ||
      this._router.url.startsWith("/email-confirm") ||
      this._router.url.startsWith("/password-reset")
    );
  }

  private refreshAuthTokensIfAccessExpired() {
    if (this._authService.isAccessTokenExpired()) {
      return this._authService.refreshAuthTokens();
    }
    return EMPTY;
  }

  private addAuthHeaderIfExist(req: HttpRequest<any>) {
    const accessToken = this._authService.getAccessToken();

    if (!accessToken) {
      return req;
    }

    return req.clone({
      headers: req.headers.set("Authorization", `Bearer ${accessToken}`),
    });
  }
}
